import React from 'react';
import { Chip, Stack, Typography } from '@mui/material';
import { APP_CONFIG } from '../../../../../config/app.config';

const colors = APP_CONFIG.ui.theme.colors;

function statusLabel(status: string): string {
  switch (status) {
    case 'active':
      return 'Active';
    case 'trialing':
      return 'Trial';
    case 'past_due':
      return 'Past due';
    case 'canceled':
      return 'Canceled';
    case 'unpaid':
      return 'Unpaid';
    case 'paused':
      return 'Paused';
    default:
      return status.replace('_', ' ');
  }
}

function statusChipSx(status: string) {
  switch (status) {
    case 'active':
      return { bgcolor: colors.success, color: colors.buttonContent };
    case 'trialing':
      return { bgcolor: colors.primary, color: colors.buttonContent };
    case 'past_due':
    case 'paused':
      return { bgcolor: colors.warning, color: colors.buttonContent };
    case 'canceled':
    case 'unpaid':
      return { bgcolor: colors.error, color: colors.buttonContent };
    default:
      return { bgcolor: colors.border, color: colors.primaryText };
  }
}

interface PlanHeaderProps {
  name: string;
  status: string;
  description?: string;
}

export const PlanHeader: React.FC<PlanHeaderProps> = ({ name, status, description }) => (
  <Stack spacing={1} sx={{ flexShrink: 0 }}>
    <Stack direction="row" spacing={1} alignItems="center">
      <Typography variant="h4">{name}</Typography>
      <Chip
        size="small"
        label={statusLabel(status)}
        sx={{
          height: 20,
          borderRadius: '6px',
          ...statusChipSx(status),
          '& .MuiChip-label': { px: 1, py: 0.25 },
        }}
      />
    </Stack>
    {description && (
      <Typography
        sx={{
          fontSize: 14,
          fontWeight: 400,
          lineHeight: '20px',
          color: colors.secondaryText,
        }}
      >
        {description}
      </Typography>
    )}
  </Stack>
);
